import { render } from "./MyOffer.vue?vue&type=template&id=8a4de1ec&scoped=true"
import script from "./MyOffer.vue?vue&type=script&lang=ts"
export * from "./MyOffer.vue?vue&type=script&lang=ts"

import "./MyOffer.vue?vue&type=style&index=0&id=8a4de1ec&lang=scss"
import "./MyOffer.vue?vue&type=style&index=1&id=8a4de1ec&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8a4de1ec"

export default script